import api from './apiService';  
import apiRoutes from './apiRoutes';

export const login = async (idNumber, password) => {
    try {
      const response = await api.post(apiRoutes.employeeLogin, {
        idNumber,
        password,
      });
        return response;  
    } catch (error) {
      throw error;   
    }
  };
export const logout = async () => {
    try {
      const response = await api.post(apiRoutes.employeeLogout)
        return response.result;  
    } catch (error) {
      throw error;   
    }
  };